import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationService } from "./authentication.service";

@Injectable()
export class BaseRestService {

  protected headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(protected httpClient: HttpClient, private authenticationService: AuthenticationService) {
    this.headers = new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "Accept-Language": "en-US"
    });
  }

  protected removeEmptyPropertyFromObject(inputObject: Object): any {
    if (!inputObject || typeof inputObject !== 'object') {
      return {};
    }
    return Object.keys(inputObject).reduce((outputObject, key) => {
      const inputValue = inputObject[key];

      if (
        inputValue !== null &&
        inputValue !== undefined &&
        inputValue !== '' &&
        (!(inputValue instanceof Array) || inputValue.length > 0)
      ) {
        outputObject[key] = inputValue;
      }

      return outputObject;
    }, {});
  }

  protected buildFormDataFromObject(inputObject): FormData {
    return Object.keys(inputObject).reduce((params: FormData, key: string) => {
      if (inputObject[key] != null && inputObject[key] != undefined) {
        params.set(key, inputObject[key]);
      }
      return params;
    }, new FormData());
  }

  protected buildQueryString(inputObjects): string {
    return Object.keys(this.removeEmptyPropertyFromObject(inputObjects))
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(inputObjects[key])}`)
      .join('&');
  }

}
